module.exports = __webpack_public_path__ + "static/media/campaignDefault.d6476793.png";